interface Props {
  typingUsers: Array<{ userId: string; userName: string }>;
}

export default function TypingIndicator({ typingUsers }: Props) {
  if (typingUsers.length === 0) return <div className="h-6" />;

  let text: string;
  if (typingUsers.length === 1) {
    text = `${typingUsers[0].userName}님이 입력 중`;
  } else if (typingUsers.length === 2) {
    text = `${typingUsers[0].userName}, ${typingUsers[1].userName}님이 입력 중`;
  } else {
    text = `${typingUsers.length}명이 입력 중`;
  }

  return (
    <div className="h-6 px-4 flex items-center text-sm text-gray-400">
      <span className="inline-flex gap-[2px] mr-2">
        <span className="size-1 bg-gray-400 rounded-full animate-bounce [animation-delay:0ms]" />
        <span className="size-1 bg-gray-400 rounded-full animate-bounce [animation-delay:150ms]" />
        <span className="size-1 bg-gray-400 rounded-full animate-bounce [animation-delay:300ms]" />
      </span>
      <span>{text}</span>
    </div>
  );
}
